module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.84cf469.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sapporo/font/notokr-bold.woff
// module id = tIv3
// module chunks = 0